import { Tag, Tooltip } from 'antd';
import moment from 'moment';
import React from 'react';
import { defaultFormat } from '../../../config/constants';
import { translations } from '../../../config/translations';

/** Certificate validity date: green while valid, red once the day has passed (as in the Excel export). */
const CertificateValidity: React.FC<{ validUntil?: Date }> = ({ validUntil }) => {
    if (!validUntil) {
        return null;
    }

    const date = moment(validUntil);
    const expired = date.isBefore(moment(), 'day');
    const tag = <Tag color={expired ? 'red' : 'green'}>{date.format(defaultFormat)}</Tag>;

    return expired ? <Tooltip title={translations.tools.certificateExpired}>{tag}</Tooltip> : tag;
};

export default CertificateValidity;
